import { render, staticRenderFns } from "./XmFeedbackBtn.vue?vue&type=template&id=f6eaf3d2&scoped=true"
import script from "./XmFeedbackBtn.vue?vue&type=script&lang=js"
export * from "./XmFeedbackBtn.vue?vue&type=script&lang=js"
import style0 from "./XmFeedbackBtn.vue?vue&type=style&index=0&id=f6eaf3d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6eaf3d2",
  null
  
)

export default component.exports